module.exports = __webpack_public_path__ + "drinktea.2e475878.png";